import { render } from "./RiBtnDel.vue?vue&type=template&id=870a9ac8"
import script from "./RiBtnDel.vue?vue&type=script&lang=js"
export * from "./RiBtnDel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiBtnDel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "870a9ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('870a9ac8', __exports__)) {
    api.reload('870a9ac8', __exports__)
  }
  
  module.hot.accept("./RiBtnDel.vue?vue&type=template&id=870a9ac8", () => {
    api.rerender('870a9ac8', render)
  })

}


export default __exports__